import React, { Fragment, useEffect, useState } from "react";

import ChannelsAndPacksComponent from "../../FormFields/ChannelsAndPacks/ChannelsAndPacksComponent";
import FilterConfirmation from "../../FormFields/FilterConfirmationComponent/FilterConfirmation";

export default function MessageA59(props) {
  const { text_data, code } = props.item;

  // console.log(text_data,"hererere")
  const channelList = text_data?.channels?.channelList;
  const packList = text_data?.packsWithChannel?.packList;
  const selectedLanguagesProps = text_data?.filter?.language?.selectedLanguages;

  const allLanguagesProps = text_data?.filter?.language?.listOfLanguages;

  const selectedGenresProps = text_data?.filter?.genre?.selectedGenre;

  const allGenresProps = text_data?.filter?.genre?.listOfGenre;

  const selectedHDSDProps = text_data?.filter?.hdOrSd;

  const filterShowOnlyChannels =  text_data?.filterShowOnlyChannels
  const showViewOnlyChannels = text_data?.showViewOnlyChannels

  const [apllied, setApplied] = useState(false);

  const handleFilterApplied = (data) => {
    setApplied(true);
  };

  const handleFilterClickHere = (code, data, tag) => {
    //  console.log(code,data,tag);
    //used to modify filters from packs and selection component
  };
  const onHandleSubmit = (code, data, tag) => {
    props.handleClick(code, data, tag);
  };

  // console.log(text_data.filter,"MESSAGEA59")
  return (
    <Fragment>
      {channelList === undefined && packList === undefined ? null : !apllied ? (
        <ChannelsAndPacksComponent
          {...props}
          channelsProps={channelList}
          packsProps={packList}
          filters={{ language: "", genre: "", hdOrSd: selectedHDSDProps }}
          prioratizePacks={text_data?.fullyMatchedPacks}
          selectedHd={text_data?.filter?.hdOrSd}
          selectedLanguagesProps={selectedLanguagesProps}
          allLanguagesProps={allLanguagesProps}
          selectedGenresProps={selectedGenresProps}
          allGenresProps={allGenresProps}
          onClickFilter={(code, data, tag) =>
            handleFilterClickHere(code, data, tag)
          }
          onClickSubmit={(code, data, tag) => {
            onHandleSubmit(code, data, tag);
          }}
          filterTag="A58"
          filterToggle={(data) => {
            handleFilterApplied(data);
          }}
          tag={props.tag}
          code={code}
          filterShowOnlyChannels={filterShowOnlyChannels}
          showViewOnlyChannels={showViewOnlyChannels}
        />
      ) : (
        <FilterConfirmation
          mainText1={"Selected Channels"}
          mainText1Data={
            JSON.parse(localStorage.getItem("selectedChannelsPAcks"))
              ?.channelName
          }
          mainText2={"Selected packs"}
          mainText2Data={
            JSON.parse(localStorage.getItem("selectedChannelsPAcks"))?.packName
          }
          from={"A59"}
        />
      )}
    </Fragment>
  );
}
